import { create } from 'zustand';

interface SelectionState {
	selection: Record<string, true>;
	addSelection: (id: string) => void;
	removeSelection: (id: string) => void;
	toggleSelection: (id: string) => void;
	clearSelection: () => void;
}

export const useSingleSelectionStore = create<SelectionState>()((set) => ({
	selection: {},
	addSelection: (id: string) =>
		set((state) => {
			const orderIdsSelected = { ...state.selection, [id]: true } as Record<string, true>;
			return { ...state, selection: orderIdsSelected };
		}),
	removeSelection: (id: string) =>
		set((state) => {
			const orderIdsSelected = { ...state.selection };
			delete orderIdsSelected[id];
			return { ...state, selection: orderIdsSelected };
		}),
	toggleSelection: (id: string) =>
		set((state) => {
			const orderIdsSelected = {
				...state.selection,
				[id]: state.selection[id] ? false : true,
			};
			if (!orderIdsSelected[id]) {
				delete orderIdsSelected[id];
			}
			return {
				...state,
				selection: orderIdsSelected as Record<string, true>,
			};
		}),
	clearSelection: () => set({ selection: {} }),
}));
